// extracted by mini-css-extract-plugin
module.exports = {"Info":"style_Info__2ABKo","Subtitle":"style_Subtitle__2ZTSN","Text":"style_Text__37adY"};